import React, { useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import { useCurrentUserContext } from 'utils/User';

import ROUTE_NAMES from 'setup/Routing/routeNames';

export default function ManagerRoute({ children }) {
  const { isOemManager, isSuperUser } = useCurrentUserContext();
  const location = useLocation();

  const shouldRedirect = useMemo(() => {
    return !(isSuperUser || isOemManager);
  }, [isOemManager, isSuperUser]);

  if (shouldRedirect) {
    return (
      <Navigate
        to={ROUTE_NAMES.access_denied}
        state={{ from: location }}
        replace
      />
    );
  }

  return <>{children}</>;
}

ManagerRoute.propTypes = {
  children: PropTypes.node,
};

ManagerRoute.defaultProps = {
  children: null,
};
